/**
 * Must stay in sync with `FilingTemplates.docChecklistToClient` in
 * `uprightlegal_crm/src/app/shared/whatsapp/templates/filing.templates.ts`
 * (including `WHATSAPP_FOOTER`).
 *
 * Used in ConfirmMessageModal for: Filing step f1 (checklist to client), Documents from Client (resend/save+send).
 */
export const DOCUMENTS_PREVIEW_TEXT = `Documents required in preparing the application for registration of Trademark :-

*Documents of Applicant*
• Proprietor - Aadhaar Card or Passport
• Company - Incorporation Certificate
• LLP - Incorporation Certificate
• Partnership - Partnership Deed & Firm Registration Certificate
• Trust - Deed
• Society - Bylaw

*Documents of Signatory*
• Aadhaar Card or Passport of Signatory

*Documents of Mark*
• Proprietor Invoices & Bills (a copy each in every 6 months from launch)
• Domain Registration Receipt & Domain Renewal Receipts
• Advertisements in Newspapers & Magazines
• News Reports / Articles in Newspapers & Magazines
• License for running business
• Agreements or MoUs of Business
• Lease or Rental Agreement
• Telephone Bills / Electricity Bills
• Bank Account Statement
• PAN Card
• Income Tax Return Acknowledgement
• GST / VAT Registration Certificate
• SSI Registration Certificate
• Registration Certificate under Shops & Commercial Establishment
• Police Clearance Certificate
• ESI Certificate
• Letter of approval from Local Administrative Bodies
• Brochures, Leaflets, Notices, Business Cards, Letter Heads etc.
• Social Media Links
• Photographs of Shops / Offices / Events
• Certificates of Awards / Achievements
• Any other document / certificate / letter in which the trademark is mentioned

_Adv. Rekha das_
_UpRight Legal Solutions_`;
